// DB url
export const PRODUCTION_DB_URL = 'https://text-nv-default-rtdb.europe-west1.firebasedatabase.app/';
export const STAGING_DB_URL = 'https://inviti-banco-collaudo.firebaseio.com/';

export const isStagingDb =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

let dbUrl = PRODUCTION_DB_URL;

if (isStagingDb) {
    console.log("loaded database in developement mode...");
    dbUrl = STAGING_DB_URL;
} else {
    console.log("loaded database in production mode...");
}

export default dbUrl;
